/**
 * Base URL for API fetch() calls.
 *
 * Production builds often set REACT_APP_API_URL=https://alefbet.app/api. If the user opens
 * https://www.alefbet.app, that becomes a cross-origin request: cookies/CORS differ and
 * audio manifest/files can fail silently → only TTS works.
 *
 * When the env host matches this page (ignoring www), use same-origin `/api` so nginx proxies.
 */
export function getApiBase() {
  const env = process.env.REACT_APP_API_URL;
  if (typeof window === "undefined") {
    return env && !String(env).startsWith("/") ? env : "/api";
  }
  if (!env) return "/api";
  if (String(env).startsWith("/")) return env;
  try {
    const loc = window.location;
    const u = new URL(env);
    const envHost = u.hostname.replace(/^www\./i, "");
    const locHost = loc.hostname.replace(/^www\./i, "");
    // Same host is not enough — localhost:3000 (dev server) and localhost:8000
    // (API) are different origins and must not collapse to a relative path.
    if (envHost === locHost && u.port === loc.port) {
      const p = u.pathname.replace(/\/$/, "") || "/api";
      return p;
    }
  } catch {
    /* ignore */
  }
  return env;
}
